export const colors = {
    primary: "#0E405F",
    default: "#CDE0FE",
};
